import { themeSettingsStore } from '@mae/components/themes';
import { i18NextStore } from '@mae/localization';
import { makeAutoObservable, reaction } from 'mobx';

export interface IApplicationConfigMae {
	language: string;
	isRightToLeftLanguage: boolean;
	rtlCss: 'rtl' | 'ltr';
	defaultLanguage: string;
}

class ApplicationConfig implements IApplicationConfigMae {
	language = 'en';
	isRightToLeftLanguage = false;
	defaultLanguage = 'en';

	constructor() {
		makeAutoObservable(this);

		reaction(
			() => this.language,
			(language) => {
				this.handleLanguageChange(language);
			}
		);

		reaction(
			() => this.isRightToLeftLanguage,
			(rtl) => {
				this.handleRtlChange(rtl);
			}
		);
	}

	get rtlCss(): 'rtl' | 'ltr' {
		return this.isRightToLeftLanguage ? 'rtl' : 'ltr';
	}

	handleRtlChange(rtl: boolean): void {
		const css = rtl ? 'rtl' : 'ltr';
		$('body').removeClass().addClass(css);
		$('body').attr('dir', css);
		document.dir = css;
		themeSettingsStore.setTextDirection(css);
	}

	handleLanguageChange(newLanguage: string): void {
		console.log(`Language changed to: ${newLanguage}`);
		i18NextStore.locale(newLanguage);
	}
}

const applicationConfigMae = new ApplicationConfig();
export default applicationConfigMae;
